import Ajax from 'global/od/Ajax';
import carousel from 'global/od/carousel';
import device from 'global/od/device';
import events from 'global/od/events';
import FormControl from 'global/form/FormControl';
import Modal from 'global/od/Modal';
import PasswordStrength from 'global/passwordStrength/PasswordStrength';
import popoverPanel from 'global/od/popoverPanel';
import Tooltip from 'global/od/Tooltip';
import util from 'global/od/util';
import OdSelect from 'global/od/OdSelect';

window.od = Object.assign(window.od || {}, {
	Ajax,
	carousel,
	device,
	events: events(),
	pubsub: events(),
	FormControl,
	Modal,
	PasswordStrength,
	popoverPanel,
	Tooltip,
	util,
	OdSelect,
});

export default window.od;
